import { SparklesCore } from "../../animations/sparkles/soarklesCore";
export function HotLogoDisplayComponent() {
  return (
    <div className="w-full h-full flex items-center justify-center flex-col gap-[19px] relative">
      <SparklesCore
        id="tsparticlesfullpage"
        background="transparent"
        minSize={0.6}
        maxSize={1.4}
        particleDensity={80}
        className="w-[450px] h-[600px] absolute top-[-50px] left-[50%] translate-x-[-50%] rotate-[45deg] rounded-[40%] overflow-hidden "
        particleColor="#FFFFFF"
      />
      <div
        style={{
          backgroundImage:
            "radial-gradient(ellipse 60% 35% at 50% 50%, rgba(240,48,0,0.48) -25%, rgba(240,48,0,0) 70%)",
          backdropFilter: "blur(0)",
          WebkitBackdropFilter: "blur(0)",
          borderRadius: "16px",
        }}
        className="w-[1000px] h-[1000px] absolute z-[3]"
      />
      <div className=" w-full  flex flex-col items-center justify-center overflow-hidden rounded-md">
        <img
          src="/logo/hot.svg"
          alt="Ahangari Holding Logo"
          className="w-[500px] h-full object-contain mt-[120px]"
        />
        <div className="relative mt-10 h-40 w-[40rem]">
          <div className="absolute inset-x-20 top-0 h-[3px] w-3/4 bg-gradient-to-r from-transparent via-white/70 to-transparent blur-md" />

          <div className="absolute inset-x-20 top-0 h-px w-3/4 bg-gradient-to-r from-transparent via-white to-transparent drop-shadow-[0_0_8px_#ffffff]" />

          <div className="absolute inset-x-60 top-0 h-[6px] w-1/4 bg-gradient-to-r from-transparent via-white/80 to-transparent blur-md" />
          <div className="absolute inset-x-60 top-0 h-px w-1/4 bg-gradient-to-r from-transparent via-white to-transparent drop-shadow-[0_0_10px_#ffffff]" />

          <div className="absolute inset-x-44 top-0 h-[2px] w-2/4 bg-gradient-to-r from-transparent via-sky-100/60 to-transparent blur-[2px]" />

          <div className="pointer-events-none absolute inset-0 h-full w-full [mask-image:radial-gradient(350px_200px_at_top,transparent_20%,white)]" />
        </div>
      </div>
    </div>
  );
}

export default HotLogoDisplayComponent;
